import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManageEmailsTable} from "../../UI/Main/ManageEmailsTable";

const ManageEmails = () => {
    return (
        <div>
            <PanelHead title="Manage Emails" />
            <PanelBody content={<ManageEmailsTable />} />
        </div>
    );
};

export default ManageEmails;
